/** @type {import("vuex/types/index.d.ts").Module} */
export const page = {
    namespaced: true,

    state: {
        key: 1,
        timer: 0,
        shows: true,
        size: { width: null, height: null },
        zoom: 1,
        loading: false,
    },

    getters: {
        width(state, gettes, rootState) {
            if (!state.size.width) return undefined;
            let padding = (() => {
                let { innerWidth } = rootState.ui.window;
                if (innerWidth < 600) return 1;
                if (innerWidth < 960) return 8;
                return 16
            })();

            return Math.round((state.size.width - padding * 2) * state.zoom);
        },
        disabled_decrease(state) {
            return state.zoom <= 0.4;
        },
        disabled_increase(state) {
            return 2 <= state.zoom;
        },
    },

    mutations: {
        increaseKey(state) {
            state.key += 1;
        },
        setSize(state, size) {
            if (848 < size?.width) size.width = 848;
            state.size = size;
        },
        setZoom(state, zoom) {
            state.zoom = zoom;
        },
        decreaseZoom(state) {
            let timer = (state.timer += 1);
            state.shows = false;
            state.zoom = +(state.zoom - 0.1).toFixed(1);
            setTimeout(() => {
                if (state.timer == timer) (state.shows = true);
            }, 200);
        },
        increaseZoom(state) {
            let timer = (state.timer += 1);
            state.shows = false;
            state.zoom = +(state.zoom + 0.1).toFixed(1);
            setTimeout(() => {
                if (state.timer == timer) (state.shows = true);
            }, 200);
        },
    },

    actions: {
        reset(store) {
            store.commit("setSize", { width: null, height: null });
            store.commit("setZoom", 1);
        },
    },
};

export default page;
